import React from 'react'
import { useTranslation } from 'react-i18next'

import { DashboardPageLayout } from '@/components/layouts/dashboard-page-layout'
import { OperationLogLegacyScreen } from './operation-log-legacy-screen'

/** 操作ログ（旧）: GET …/operation-log。ルート `/operation-log/legacy` 専用。 */
export const OperationLogLegacyPage: React.FC = () => {
  const { t } = useTranslation()
  return (
    <DashboardPageLayout title={t('Operation Log')}>
      <OperationLogLegacyScreen />
    </DashboardPageLayout>
  )
}
